export const CONFIG_NAMESPACE = 'vocento.config.sportsdata';
export const CLASS_ITEM       = '.clasificacion-item';
export const CLASS_ITEM_LAST  = '.voc-ns-last-jornada';



// WEBPACK FOOTER //
// ./src/constants.js